import React from "react";
import Carousel from "react-material-ui-carousel";
import Image from "mui-image";

const SignInCarousel = function () {
  const items = [
    {
      image:
        "https://lakeofdreams.org/static/media/Lodi-MR.705218d186deaabdefce.png",
    },
    {
      image:
        "https://lakeofdreams.org/static/media/Retreat.e0abe7ff2e8b4be6512a.png",
    },
    {
      image:
        "https://lakeofdreams.org/static/media/Ladies_Retreat.13fdd6bb328a916a0a22.jpeg",
    },
  ];

  return (
    <Carousel interval={10000}>
      {items.map((item, i) => (
        <Image key={`key-${i + 1}`} src={item.image} />
      ))}
    </Carousel>
  );
};

export default SignInCarousel;
